// §4.4 partial — admin/plans routes.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const PlansListPage = lazyWithRetry(() => import("./pages/PlansListPage"));
const PlanDetailPage = lazyWithRetry(() => import("./pages/PlanDetailPage"));
const PlanSalesHistoryPage = lazyWithRetry(
  () => import("./pages/PlanSalesHistoryPage"),
);
const PlanAnalyticsPage = lazyWithRetry(
  () => import("./pages/PlanAnalyticsPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/plans", Component: PlansListPage },
      { path: "/admin/plans/analytics", Component: PlanAnalyticsPage },
      { path: "/admin/plans/:id", Component: PlanDetailPage },
      {
        path: "/admin/plans/:id/sales-history",
        Component: PlanSalesHistoryPage,
      },
    ],
  },
];

export default routes;
